import getDocuments from "@/api/documents/getDocuments";
import setDocuments from "@/api/documents/setDocuments";
import deleteDocument from "@/api/documents/deleteDocument";

const state = { documents: [], singleDocument: null };

const actions = {
    getDocumentsAction({ commit }, query) {
        return new Promise((resolve, reject) => {
            getDocuments.call(this, query).then(response => {
                if (response.status == 'OK') {
                    commit('setDocumentsMutation', { documents: response.data })
                    resolve(response.data)
                }
                else { reject(new Error(response.message)) }
            }).catch(e => { reject(new Error(e)) })
        })
    },
    createDocumentAction({ commit }, { data }) {
        return new Promise((resolve, reject) => {
            setDocuments.call(this, { data }).then(response => {
                if (response.status == 'OK') {
                    const document = Array.isArray(response.data) ? response.data[0] : response.data
                    commit('updateDocumentsMutation', { documents: [document] })
                    resolve(document)
                }
                else { reject(new Error(response.message)) }
            }).catch(e => { reject(new Error(e)) })
        })
    },
    deleteDocumentAction({ commit }, id) {
        return new Promise((resolve, reject) => {
            deleteDocument.call(this, id).then(response => {
                if (response.status == 'OK') {
                    commit('deleteDocumentMutation', { id })
                    resolve(response.data)
                }
                else { reject(new Error(response.message)) }
            }).catch(e => { reject(new Error(e)) })
        })
    },
    clearDocumentsAction({ commit }) {
        commit('clearDocumentsMutation')
    }
}

const mutations = {
    setDocumentsMutation(state, { documents }) {
        state.documents = documents
    },
    updateDocumentsMutation(state, { documents }) {
        documents.forEach(document => {
            const index = state.documents.findIndex(d => d.id == document.id)
            if (index !== -1) {
                state.documents.splice(index, 1, document)
            } else {
                state.documents = [document, ...state.documents]
            }
        })
    },
    deleteDocumentMutation(state, { id }) {
        state.documents = state.documents.filter(d => d.id != id)
    },
    clearDocumentsMutation(state) {
        state.documents = []
        state.singleDocument = null
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
